module.exports = __webpack_public_path__ + "img/icon-other.b2a31eed.png";